import styled from 'styled-components';

import FlexBox from '../FlexBox';

const Container = styled(FlexBox)`
  width: calc(100% - 2.5rem);
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
`;

export default Container;
